import { render, staticRenderFns } from "./Cooperation.vue?vue&type=template&id=66bae286&scoped=true&"
import script from "./Cooperation.vue?vue&type=script&lang=ts&"
export * from "./Cooperation.vue?vue&type=script&lang=ts&"
import style0 from "./Cooperation.vue?vue&type=style&index=0&id=66bae286&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66bae286",
  null
  
)

export default component.exports